import { Route } from '@angular/router';
import { authGuard } from '../../core/login/guards/auth.guard';
import { ProtectedComponent } from './protected';

export const protectedRoutes: Route[] = [
    {
        path: 'protected',
        canActivate: [authGuard],
        component: ProtectedComponent,
        children: [
            {
                path: 'home',
                loadComponent: () =>
                    import('./home/home').then(
                        (m) => m.HomeComponent,
                    ),
                data: { title: '' },
            },
            {
                path: 'data-exchange',
                loadComponent: () =>
                    import('./data-exchange/data-exchange')
                        .then(m => m.DataExchangeComponent),
                loadChildren: () =>
                    import('./data-exchange/data-exchange.routes')
                        .then(m => m.dataExchangeRoutes),
                data: { title: 'Data Exchange' },
            } ,
            {
                path: 'data-analytics',
                loadComponent: () =>
                    import('./data-analytics/data-analytics').then(
                        (m) => m.DataAnalyticsComponent,
                    ),
                data: { title: 'Data Analytics' },
            },
            {
                path: 'hvz',
                loadComponent: () =>
                    import('./hvz/hvz').then(
                        (m) => m.HvzComponent,
                    ),
                data: { title: 'HvZ' },
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
                data: { title: '' },
            },
            {
                path: '**',
                redirectTo: 'home',
                data: { title: '' },
            },
        ],
    },
];
